import { NgModule } from '@angular/core'
import { DisplayNumberPipe } from './display-number.pipe'

@NgModule({
    declarations: [DisplayNumberPipe],
    exports: [DisplayNumberPipe],
    providers: [DisplayNumberPipe],
})
export class DisplayNumberModule {
}